import React from 'react';
import DiagrameDataBase from '../../assets/baseDonne.png';
import c from '../../assets/c.png';
import DiagrameClass from '../../assets/class.png';
import github from '../../assets/github.png';
import listPatient from '../../assets/pi2.png';
import CreatePatient from '../../assets/pi3.png';
import CreatePatient2 from '../../assets/pi4.png';
import history from '../../assets/pi5.png';
import Calendar from '../../assets/pi7.png';
import login from '../../assets/Screenshot1.png';
import calender2 from '../../assets/Screenshot6.png';
import sql from '../../assets/sql.png';
import UseCase from '../../assets/UseCases.png';
import vs from '../../assets/vs.png';
import './gestdent.css';

const UseCases = () => {
  return (
    <section id="UseCases" className="container">
      {/* ------------------------------- UseCases ------------------------------------------ */}
      <h2>Identification of Use Cases</h2>
      <div className="usecase">
        <p>&nbsp;&nbsp;&nbsp;&nbsp;A use case represents a set of action sequences performed by the system that produce an observable result of interest to a particular actor. It allows describing what the future system will need to do, without specifying how it will accomplish it.</p>
        <div className="usecase-img">
          <img src={UseCase} alt="UseCase" />
        </div>
      </div>
      {/* ------------------------------- Class Diagram ------------------------------------------ */}
      <h2>Class Diagram</h2>
      <div className="usecase-img">
        <img src={DiagrameClass} alt="UseCase" />
      </div>
      {/* ------------------------------- Database Diagram ------------------------------------------ */}
      <h2>Database Diagram</h2>
      <div >
        <img src={DiagrameDataBase} style={{borderRadius:'3rem auto', marginBottom:'3rem'}} alt="UseCase" />
      </div>
      {/* ------------------------------- Presentation of Interfaces ------------------------------------------ */}
      <h2>Presentation of Interfaces</h2>
      <h5>Login</h5>
      <div className="usecase-img">
        <img src={login} style={{ width: '400px',height:'400px' ,margin:'auto' ,borderRadius:'1rem' }} alt="UseCase" />
      </div>
      <h5>List of patient</h5>
      <div >
        <img src={listPatient} style={{ margin:'3rem auto' ,borderRadius:'1rem' }} alt="UseCase" />
      </div>
      <h5>Create a new patient</h5>
      <div >
        <img src={CreatePatient} style={{ margin:'3rem auto' ,borderRadius:'1rem' }} alt="UseCase" />
      </div>
      <div >
        <img src={CreatePatient2} style={{ margin:'3rem auto' ,borderRadius:'1rem' }} alt="UseCase" />
      </div>
      <h5>History </h5>
      <div >
        <img src={history} style={{ margin:'3rem auto' ,borderRadius:'1rem' }} alt="UseCase" />
      </div>
      <h5>Calendar appointment management</h5>
      <div >
        <img src={Calendar} style={{ margin:'3rem auto' ,borderRadius:'1rem' }} alt="UseCase" />
      </div>
      <div className="usecase-img">
        <img src={calender2} style={{ width: '400px',height:'400px' ,margin:'auto' ,borderRadius:'1rem' }} alt="UseCase" />
      </div>
      {/* ------------------------------- Development Tools and Platforms ------------------------------------------ */}
      <h2>Development Tools and Platforms</h2>
      <div className="tools" >
        <img src={sql} style={{ width: '300px', }}  alt="UseCase" />
        <img src={vs} style={{ width: '150px',height:'160px'  }} alt="UseCase" />
        <img src={c} style={{  width: '150px',height:'150px'  }} alt="UseCase" />
        <img src={github} style={{ width: '200px'   }} alt="UseCase" />
      </div>
      <h2>Developed by</h2>
      <h5>Aoumara Yacine and Baghdadi wassim</h5>

    </section>
  );
};

export default UseCases;
